let isCollectMode = false;
export const setIsCollectMode = (v) => {isCollectMode = v};
export const getIsCollectMode = () => isCollectMode;
export let setClickHeatmapAttribute = null;
export const heatmapClass = 'js-c-heatmap';
export const heatmapDataIdKey = 'data-c-heatmap-id';
export const heatmapDomChangeDataIdKey = 'data-c-heatmap-state-id';
export const heatmapHasLink = 'data-c-heatmap-has-link';
export const heatmapAttentionClass = 'js-c-heatmap-attention';
export const heatmapArrivalClass = 'js-c-heatmap-arrival';
export const heatmapClickClass = 'js-c-heatmap-click';

export const INTERSECTION_THRESHOLDS_MAP = {
  0.5:   [0, 0.5, 1.0],
  0.25:  [0, 0.25, 0.5, 0.75, 1.0],
  0.125: [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1.0],
  0.0625:[0, 0.0625, 0.125, 0.1875, 0.25, 0.3125, 0.375, 0.4375, 0.5,0.5625, 0.625, 0.6875, 0.75, 0.8125, 0.875, 0.9375, 1.0],
};

export const DOM_STABLE_DURATION = 300;  // 300ms 変化なしで安定とみなす
export const DOM_INIT_FORCE_STANDBY_MS = 10000;
export const DOM_INIT_COMPLETE_STANDBY_MS = 500;
export const DOM_CHANGE_DEBOUNCE_MS = 300;
export const DOM_CHANGE_OBSERVE_MIN_HEIGHT = 380;
export const DOM_CHANGE_OBSERVE_MAX_HEIGHT = DOM_CHANGE_OBSERVE_MIN_HEIGHT * 1.5;

export const HEATMAP_RENDER_DEBOUNCE_MS = 200;
export const HEATMAP_PREVIEW_HASH_HEIGHT = 240;

export const ATTENTION_BUCKET_MIN_HEIGHT = 180;
export const ATTENTION_BUCKET_MAX_HEIGHT = 1200;

export const HEATMAP_SOCKET_PARAM_KEY = 'c-heatmap-sock';
export const HEATMAP_COLLECT_WS = `https://heatmap.support-inc.co.jp/collect`;
export const HEATMAP_PREVIEW_WS = `/api/heatmap/preview/query`;
export const HEATMAP_DEFAULT_ORIGIN = 'https://heatmap.support-inc.co.jp';
export const HEATMAP_STATE_DATA_IDS_JSON_WS = 'https://heatmap.support-inc.co.jp/delivery/lp-state-key-jsons';
export const ALLOWED_ORIGINS = [
  'https://heatmap.support-inc.co.jp',
];

export const domChangeObserveTargetTags = [
    'DIV',
    'H1',
    'H2',
    'H3',
    'H4',
    'LI',
    'OL',
    'UL',
    'ARTICLE',
    'SECTION',
    'TABLE',
    'IMG',
    'VIDEO',
    'IFRAME',
];

export const stateKeyTargetTags = [
    'HEADER',
    'MAIN',
    'FOOTER',
    'DIV',
    'H1',
    'H2',
    'H3',
    'H4',
    'LI',
    'OL',
    'UL',
    'ARTICLE',
    'SECTION',
    'TABLE',
    'P',
];

export const attentionTargetTags = [
    'HEADER',
    'MAIN',
    'FOOTER',
    'DIV',
    'H1',
    'H2',
    'H3',
    'H4',
    'LI',
    'OL',
    'UL',
    'ARTICLE',
    'SECTION',
    'TABLE',
    'P',
    'A',
    'IMG',
    'VIDEO',
    'IFRAME',
];

export const clickTargetTags = [
    'HEADER',
    'MAIN',
    'FOOTER',
    'DIV',
    'H1',
    'H2',
    'H3',
    'H4',
    'LI',
    'OL',
    'UL',
    'ARTICLE',
    'SECTION',
    'TABLE',
    'P',
    'A',
    'IMG',
    'VIDEO',
    'BUTTON',
    'LABEL',
    'INPUT',
    'SELECT',
    'TEXTAREA',
];

/**
 *
 * @param {*} scriptName
 * @returns
 */
export function getScriptDirPath(scriptName) {
    let path = '';
    let scripts = document.getElementsByTagName("script");
    let i = scripts.length;
    let reg = new RegExp(`(^|.*\/)${scriptName}\.js$`);
    while (i--) {
        let match = scripts[i].src.match(reg);
        if (match) {
            path = match[1];
            break;
        }
    }

    return path;
}

/**
 *
 * ヒートマップ用の属性付与
 */
export function setHeatmapAttribute(docElement, {reconcile = false, reuseIds = false} = {}) {

    // Preview updates retain unchanged attributes. Collect candidates before writing
    // classes so geometry reads do not repeatedly force layout after each write.
    const desired = new Map();
    let committing = false;
    const previous = docElement.querySelectorAll(`.${heatmapClass}, .${heatmapClickClass}, .${heatmapAttentionClass}, .${heatmapArrivalClass}, [${heatmapDataIdKey}]`);

    if (!reconcile) previous.forEach(el => {
      el.classList.remove(heatmapClass);
      el.classList.remove(heatmapClickClass);
      el.classList.remove(heatmapAttentionClass);
      el.classList.remove(heatmapArrivalClass);
      el.removeAttribute(heatmapDataIdKey);
      el.removeAttribute(heatmapHasLink);
    });

    const exclusionClassNames = [
      'heatmap-preview-attention-second-container',
      'heatmap-preview-attention-second',
      'heatmap-preview-attention-second-per',
      'heatmap-preview-arrival-container',
      'heatmap-preview-arrival',
      'heatmap-preview-arrival-per',
      'heatmap-preview-arrival-transition-container',
      'heatmap-preview-arrival-transition',
      'heatmap-preview-arrival-transition-per',
      'heatmap-preview-leave-container',
      'heatmap-preview-leave',
      'heatmap-preview-leave-per',
      'heatmap-preview-fixed-container',
      'heatmap-tooltip',
      'heatmap-canvas',
      'heatmap-preview-click-count-container',
      'heatmap-preview-click-count',
      'heatmap-preview-tile-layer',
      'heatmap-preview-tile',
    ];

    //==============================
    // 位置取得・キャッシュ ↓↓↓
    //==============================
    const rectCache = new WeakMap();
    const styleCache = new WeakMap();

    const nthCache = new WeakMap();
    const parentTagNthCache = new WeakMap();

    /**
     * ノイズ要素を除いたNthを取得
     * @param {*} parent 
     * @param {*} tagName 
     * @returns 
     */
    const buildNthIndex = (parent, tagName) => {
      let tagMap = parentTagNthCache.get(parent);
      if (!tagMap) {
        tagMap = new Map();
        parentTagNthCache.set(parent, tagMap);
      }
      if (tagMap.has(tagName)) return;

      const index = new Map();
      let nth = 0;
      const children = parent.children;
      for (let i = 0, len = children.length; i < len; i++) {
        const child = children[i];
        if (child.tagName !== tagName) continue;
        nth++;
        index.set(child, nth);
        nthCache.set(child, nth);
      }
      tagMap.set(tagName, index);
    };

    /**
     * nthOfType系のキャッシュ
     * @param {*} node 
     * @returns 
     */
    const getNthOfType = (node) => {
      if (!node || !node.parentElement) return 1;

      const cached = nthCache.get(node);
      if (cached !== undefined) return cached;

      const parent = node.parentElement;
      const tagName = node.tagName;

      buildNthIndex(parent, tagName);

      return nthCache.get(node) || 1;
    };

    /**
     * nthOfType系の取得（キャッシュなし）
     * @param {*} node 
     * @returns 
     */
    const getNthOfTypeNoCache = node => {
      if (!node || !node.parentElement) return 1;
      const tag = node.tagName;
      const children = node.parentElement.children;
      let nth = 0;
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child.tagName !== tag) continue;
        nth++;
        if (child === node) return nth;
      }
      return 1;
    };


    //==============================
    // 属性付与関数 ↓↓↓
    //==============================
    const setAttr = (el, type) => {
        if (reconcile && !committing) {
          if (!desired.has(el)) desired.set(el, new Set());
          desired.get(el).add(type);
          return;
        }
        
        if (type === 'attention') {
          if(!isAttentionCandidateElement(el, rectCache, styleCache) || (!reconcile && el.classList.contains(heatmapAttentionClass))) return;
        }

        //IMGはマーケティングタグかどうかで所外
        if (el.tagName === 'IMG') {
            const cs = type === 'click' && !reconcile ? getComputedStyle(el) : getStyle(el, styleCache);
            const w = parseFloat(cs.width) || el.naturalWidth || 0;
            const h = parseFloat(cs.height) || el.naturalHeight || 0;
            if (cs.display === 'none' || cs.visibility === 'hidden' || w <= 2 || h <= 2) return;
        }

        for(let c of exclusionClassNames) {
            if(el.classList.contains(c)) {
              return;
            }
        }

        if((reconcile || !el.classList.contains(heatmapClickClass)) && type == 'click') {
            if (!el.classList.contains(heatmapClass)) el.classList.add(heatmapClass);
            if (!el.classList.contains(heatmapClickClass)) el.classList.add(heatmapClickClass);

            if(el.tagName === 'A' || el.closest('a')) {
              const a = el.tagName === 'A' ? el : el.closest('a');
              const href = (a.getAttribute('href') || '').trim();
              const isRealLink = (() => {
                if(href == '') return false;
                if(href.startsWith('#')) return false;
                if(href.toLowerCase().startsWith('javascript:')) return false;
                return true;
              })();

              if(isRealLink && el.getAttribute(heatmapHasLink) !== '1') {
                  el.setAttribute(heatmapHasLink, '1');
              } else if (!isRealLink && reconcile) {
                  el.removeAttribute(heatmapHasLink);
              }
            } else if (reconcile) {
              el.removeAttribute(heatmapHasLink);
            }
        }

        if((reconcile || !el.classList.contains(heatmapAttentionClass)) && type == 'attention') {
            if (!el.classList.contains(heatmapAttentionClass)) el.classList.add(heatmapAttentionClass);
            
            if(isArrivalElement(el)) {
                if (!el.classList.contains(heatmapArrivalClass)) el.classList.add(heatmapArrivalClass);
            } else if (reconcile && el.classList.contains(heatmapArrivalClass)) {
                el.classList.remove(heatmapArrivalClass);
            }
        }

        if (reconcile && reuseIds && el.hasAttribute(heatmapDataIdKey)) return;
        const hashBaseAttributes = [];

        //タグ名
        hashBaseAttributes.push(['tagName', el.tagName]);

        //階層の深さ
        let level = 1;
        if(el.parentElement) {
            let tmpEl = el;
            while(tmpEl.parentElement) {
                level++;
                tmpEl = tmpEl.parentElement;
            }
        }
        hashBaseAttributes.push(['level', level]);
        // クリック系はキャッシュを使わない
        hashBaseAttributes.push(['nthOfType', type === 'click' ? getNthOfTypeNoCache(el) : getNthOfType(el)]);

        //先祖要素も同じようにレベルとnthOfType追加する
        let parentElementLevel = level;
        let parentElement = el.parentElement ? el.parentElement : false;
        let cnt = 1;
        while(parentElement) {
            parentElementLevel--;
            // クリック系はキャッシュを使わない
            const parentNthOfType = type === 'click' ? getNthOfTypeNoCache(parentElement) : getNthOfType(parentElement);

            const m = [];
            m.push(['tagName', parentElement.tagName]);
            m.push(['level', parentElementLevel]);
            m.push(['nthOfType', parentNthOfType]);
            hashBaseAttributes.push([`parentUp${cnt}`, m]);

            if(parentElement.parentElement) {
                parentElement = parentElement.parentElement;
            } else {
                parentElement = false;
            }
            
            cnt++;
        }

        const heatmapIdHash = murmurhash2(JSON.stringify(hashBaseAttributes));

        if(el.getAttribute(heatmapDataIdKey) !== heatmapIdHash) {
            el.setAttribute(heatmapDataIdKey, heatmapIdHash);
        }
    };

    setClickHeatmapAttribute = (el) => setAttr(el, 'click');

    /**
     * 滞在要素群の判定
     * @param {*} elements 
     * @param {*} tagSets 
     * @returns 
     */
    const attentionPickLeavesFilter = (elements, tagSets) => {
        // 画像・動画など中身を持たないタグ
        const mediaLikeTags = new Set(['IMG', 'VIDEO', 'IFRAME', 'CANVAS', 'SVG']);
        const imageLikeTags = new Set(['IMG', 'VIDEO', 'CANVAS', 'SVG']);

        // 1. 基本候補
        const candidates = new Set();
        for(const el of elements) {
            if(!isAttentionCandidateElement(el, rectCache, styleCache)) continue;

            const rect = getRect(el, rectCache);
            const h = rect.height;

            if (el.tagName === 'A' && h < 50) continue;
            // メディアタグ以外ででかすぎる要素は除外
            if (h > ATTENTION_BUCKET_MAX_HEIGHT && !mediaLikeTags.has(el.tagName)) continue;
            if (el.tagName === 'FOOTER') continue;
            if (el.tagName === 'A' && h >= 50) candidates.add(el);
            if (h >= 50 && imageLikeTags.has(el.tagName)) candidates.add(el);
            if (h >= ATTENTION_BUCKET_MIN_HEIGHT) candidates.add(el);
        }

        // 2. 親子関係解決：親と子の両方が候補なら "子を優先"
        const nonLeaves = new Set();
        for (const el of candidates) {
            let p = el.parentElement;
            while (p && p !== document.documentElement) {
                if (candidates.has(p)) {
                    nonLeaves.add(p);
                }
                p = p.parentElement;
            }
        }

        // 候補一覧
        const stackLeaves = [...candidates].filter(el => !nonLeaves.has(el));
        const stackLeavesSet = new Set(stackLeaves);

        // 3. 重なり補正：そのポイントで重なっている候補の中から「高さ最大」を選択する
        const isFromPointOfParent = (targetEl, rect, leaves) => {
          const visibleLeft   = Math.max(rect.left, 0);
          const visibleRight  = Math.min(rect.right, window.innerWidth);
          const visibleTop    = Math.max(rect.top, 0);
          const visibleBottom = Math.min(rect.bottom, window.innerHeight);
          const hasIntersection = visibleRight > visibleLeft && visibleBottom > visibleTop;

          if (!hasIntersection) return true;

          const x = (visibleLeft + visibleRight) / 2;
          const y = (visibleTop + visibleBottom) / 2;
          const hitElements = document.elementsFromPoint(x, y) ?? [];

          let winner = null;
          let winnerHeight = -1;

          for(const el of hitElements) {
            if (!leaves.has(el)) continue;

            // 最初の判定でも弾いてるが念の為ここでも可視状態含めて候補チェック
            if(!isAttentionCandidateElement(el, rectCache, styleCache)) continue;

            const rect = getRect(el, rectCache);
            const h = rect.height;

            if (h > ATTENTION_BUCKET_MAX_HEIGHT && !mediaLikeTags.has(el.tagName)) continue;

            if (h > winnerHeight) {
              winnerHeight = h;
              winner = el;
            }
          }

          if(!winner) return false;
          return winner === targetEl;
        };

        const leaves = [];
        for (const el of stackLeaves) {
            const rect = getRect(el, rectCache);
            if(isFromPointOfParent(el, rect, stackLeavesSet)) leaves.push(el);
        }

        return leaves;
    };

    attentionPickLeavesFilter(
      Array.from(document.querySelectorAll(attentionTargetTags.join(','))).filter(el => !el.closest?.('.heatmap-preview-tile-layer')),
      new Set(attentionTargetTags)
    ).forEach(el => setAttr(el, 'attention'));

    if(!isCollectMode) { 
      //プレビューモードのときだけあらかじめ付与 ※収集側はクリック時にひとつずつ付与
      document.querySelectorAll(clickTargetTags.join(',')).forEach(el => {
        if (!el.closest?.('.heatmap-preview-tile-layer')) setAttr(el, 'click');
      });
    }
    if (reconcile) {
      committing = true;
      // Recheck tiny/hidden tracking images using the same exclusion as setAttr.
      for (const [el] of desired) {
        if (exclusionClassNames.some(c => el.classList.contains(c))) desired.delete(el);
        else if (el.tagName === 'IMG') {
          const cs = getStyle(el, styleCache);
          if (cs.display === 'none' || cs.visibility === 'hidden' ||
              (parseFloat(cs.width) || el.naturalWidth || 0) <= 2 ||
              (parseFloat(cs.height) || el.naturalHeight || 0) <= 2) desired.delete(el);
        }
      }
      previous.forEach(el => {
        const types = desired.get(el);
        if (!types?.has('click')) {
          if (el.classList.contains(heatmapClass)) el.classList.remove(heatmapClass);
          if (el.classList.contains(heatmapClickClass)) el.classList.remove(heatmapClickClass);
          el.removeAttribute(heatmapHasLink);
        }
        if (!types?.has('attention')) {
          if (el.classList.contains(heatmapAttentionClass)) el.classList.remove(heatmapAttentionClass);
          if (el.classList.contains(heatmapArrivalClass)) el.classList.remove(heatmapArrivalClass);
        }
        if (!types) el.removeAttribute(heatmapDataIdKey);
      });
      for (const [el, types] of desired) {
        for (const type of types) setAttr(el, type);
      }
    }
}

/**
 * 滞在要素の取得
 * @returns 
 */
let getHeatmapAttentionElementsTimerId = null;
let getHeatmapAttentionElementsPromise = null;
let getHeatmapAttentionElementsResolve = null;
export const getHeatmapAttentionElements = () => {
  clearTimeout(getHeatmapAttentionElementsTimerId);

  if (!getHeatmapAttentionElementsPromise) {
    getHeatmapAttentionElementsPromise = new Promise((resolve) => {
      getHeatmapAttentionElementsResolve = resolve;
    });
  }

  getHeatmapAttentionElementsTimerId = setTimeout(() => {
    const result = document.querySelectorAll(`.${heatmapAttentionClass}`);

    if(getHeatmapAttentionElementsResolve) getHeatmapAttentionElementsResolve(result);

    getHeatmapAttentionElementsPromise = null;
    getHeatmapAttentionElementsResolve = null;
  }, 100);

  return getHeatmapAttentionElementsPromise;
}

/**
 * クリック要素の取得
 * @returns 
 */
let getHeatmapClickElementsTimerId = null;
let getHeatmapClickElementsPromise = null;
let getHeatmapClickElementsResolve = null;
export const getHeatmapClickElements = () => {
  clearTimeout(getHeatmapClickElementsTimerId);

  if (!getHeatmapClickElementsPromise) {
    getHeatmapClickElementsPromise = new Promise((resolve) => {
      getHeatmapClickElementsResolve = resolve;
    });
  }

  getHeatmapClickElementsTimerId = setTimeout(() => {
    const result = document.querySelectorAll(`.${heatmapClickClass}`);

    if(getHeatmapClickElementsResolve) getHeatmapClickElementsResolve(result);

    getHeatmapClickElementsPromise = null;
    getHeatmapClickElementsResolve = null;
  }, 100);

  return getHeatmapClickElementsPromise;
}

/**
 * DOM変更監視対象要素取得
 * @returns 
 */
const DOM_CHANGE_OBSERVE_MAX = 250; //監視要素の爆増対策で上限は設ける
let getHeatmapDomChangeObserveElementsTimerId = null;
let getHeatmapDomChangeObserveElementsPromise = null;
let getHeatmapDomChangeObserveElementsResolve = null;
export const getHeatmapDomChangeObserveElements = () => {
  clearTimeout(getHeatmapDomChangeObserveElementsTimerId);

  if (!getHeatmapDomChangeObserveElementsPromise) {
    getHeatmapDomChangeObserveElementsPromise = new Promise((resolve) => {
      getHeatmapDomChangeObserveElementsResolve = resolve;
    });
  }

  getHeatmapDomChangeObserveElementsTimerId = setTimeout(() => {
    
    const rectCache = new WeakMap();
    const styleCache = new WeakMap();

    const elements = Array.from(document.querySelectorAll(domChangeObserveTargetTags.join(','))).filter(el => !el.closest?.('.heatmap-preview-tile-layer'));
    const observeSet = new Set();

    const candidate1AncestorSet = new Set();
    const candidate1Set = new Set();
    const candidate2AncestorSet = new Set();
    const candidate2Set = new Set();

    // 大きさ判定
    const isViewHeightOk = (el, level) => {
      const rect = getRect(el, rectCache);
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if(level === 1) {
        return (rect.height >= DOM_CHANGE_OBSERVE_MIN_HEIGHT && rect.height <= DOM_CHANGE_OBSERVE_MAX_HEIGHT) || (rect.height >= (viewportHeight * 0.8) && rect.height <= (viewportHeight * 1.35))
      }

      if(level === 2) {
        return rect.height >= (DOM_CHANGE_OBSERVE_MIN_HEIGHT * 0.6) && rect.height < DOM_CHANGE_OBSERVE_MIN_HEIGHT
      }

      if(level === 'fixed') {
        //モーダルとかある程度の大きさは見張りつつ、フローティングCTAなどは無視するライン
        return rect.height >= (DOM_CHANGE_OBSERVE_MIN_HEIGHT / 2);
      }

      return false;
    };

    // 自分自身が非表示かどうか
    const hasSelfHiddenStyle = (el) => {
      if (!el || el.nodeType !== 1) return false;
      const style = getStyle(el, styleCache);
      return style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0;
    };

    // 祖先が非表示かどうか
    const hasAncestorHiddenStyle = (el) => {
      if (!el || el.nodeType !== 1) return false;
      let currentElement = el?.parentElement;
      while(currentElement && currentElement.nodeType === 1) {
        if (currentElement.tagName === 'MAIN' || currentElement.tagName === 'BODY') {
          break;
        }

        const style = getStyle(currentElement, styleCache);

        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0) {
          return true;
        }

        currentElement = currentElement.parentElement;
      }

      return false;
    };

    // 非表示要素を持つ祖先要素を追加
    const addCandidateAncestor = (el, candidateSet) => {
      let currentElement = el?.parentElement;
      while(currentElement && currentElement.nodeType === 1) {
        if (currentElement.tagName === 'MAIN' || currentElement.tagName === 'BODY') {
          break;
        }

        const style = getStyle(currentElement, styleCache);
        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0) {
          candidateSet.add(currentElement);
        }
        
        const isFixedEl = isFixed(currentElement, rectCache, styleCache) && isViewHeightOk(currentElement, 'fixed'); 
        if (isViewHeightOk(currentElement, 1) || isFixedEl) {
          candidateSet.add(currentElement);
        }

        currentElement = currentElement.parentElement;
      }
    };

    // 広告タグ疑惑判定
    const isAdTag = (el) => {
      if (!el || el.nodeType !== 1) return false;
      if (el.tagName !== 'IMG' && el.tagName !== 'IFRAME') return false;

      const rect = getRect(el, rectCache);
      const style = getStyle(el, styleCache);

      let attrWidth = el.getAttribute('width');
      let attrHeight = el.getAttribute('height');

      if ((attrWidth !== null && Number(attrWidth) <= 2) || (attrHeight !== null && Number(attrHeight) <= 2)) return true;
    
      let styleWidth = parseFloat(style.width) || rect.width;
      let styleHeight = parseFloat(style.height) || rect.height;

      if (styleWidth <= 2 || styleHeight <= 2) return true;

      return false;
    };

    // 第1段階
    for (const el of elements) {     
      if (isAdTag(el)) continue;

      // 広告タグ以外で非表示要素も見張る
      // ※今は非可視でも可視に変わる要素の可能性もあるため
      const isHiddenStyle = hasSelfHiddenStyle(el);
      const isAncestorHiddenStyle = hasAncestorHiddenStyle(el);
      const isViewHeight = isViewHeightOk(el, 1);
      const isFixedEl = isFixed(el, rectCache, styleCache) && isViewHeightOk(el, 'fixed'); 

      if (isHiddenStyle || isViewHeight || isFixedEl) {
        candidate1Set.add(el);
        addCandidateAncestor(el, candidate1AncestorSet);
      } else if (isAncestorHiddenStyle) {
        addCandidateAncestor(el, candidate1AncestorSet);  
      }
    }

    // 第2段階
    if(candidate1Set.size < 10) {
      for (const el of elements) {
        if (isAdTag(el)) continue;

        const isViewHeight = isViewHeightOk(el, 2);

        if (isViewHeight) {
          candidate2Set.add(el);
          addCandidateAncestor(el, candidate2AncestorSet);
        }
      } 
    }

    const appendObserveSet = (srcSet) => {
      for (const el of srcSet) {
        if (observeSet.size >= DOM_CHANGE_OBSERVE_MAX) break;
        observeSet.add(el);
      }
    };

    appendObserveSet(candidate1AncestorSet);
    appendObserveSet(candidate1Set);
    appendObserveSet(candidate2AncestorSet);
    appendObserveSet(candidate2Set);

    // dataId付与
    document.querySelectorAll(`[${heatmapDomChangeDataIdKey}]`).forEach(el => {
      el.removeAttribute(heatmapDomChangeDataIdKey);
    });

    const nthCache = new WeakMap();
    const parentTagNthCache = new WeakMap();

    // 正確なNthIndexを取得（ゴミっぽいタグ位置は無視）
    const buildNthIndex = (parent, tagName) => {
      let tagMap = parentTagNthCache.get(parent);
      if (!tagMap) {
        tagMap = new Map();
        parentTagNthCache.set(parent, tagMap);
      }
      if (tagMap.has(tagName)) return;

      const index = new Map();
      let nth = 0;
      const children = parent.children;
      for (let i = 0, len = children.length; i < len; i++) {
        const child = children[i];
        if (child.tagName !== tagName) continue;
        nth++;
        index.set(child, nth);
        nthCache.set(child, nth);
      }
      tagMap.set(tagName, index);
    };

    const getNthOfType = (node) => {
      if (!node || !node.parentElement) return 1;
      const cached = nthCache.get(node);
      if (cached !== undefined) return cached;
      const parent = node.parentElement;
      const tagName = node.tagName;
      buildNthIndex(parent, tagName);
      return nthCache.get(node) || 1;
    };

    for (const el of observeSet) {
      const hashBaseAttributes = [];
      hashBaseAttributes.push(['tagName', el.tagName]);

      let level = 1;
      let tmpEl = el;
      while (tmpEl.parentElement) {
        level++;
        tmpEl = tmpEl.parentElement;
      }
      hashBaseAttributes.push(['level', level]);
      hashBaseAttributes.push(['nthOfType', getNthOfType(el)]);

      let parentElementLevel = level;
      let parentElement = el.parentElement ? el.parentElement : false;
      let cnt = 1;

      while (parentElement) {
        parentElementLevel--;
        const parentNthOfType = getNthOfType(parentElement);
        const m = [];
        m.push(['tagName', parentElement.tagName]);
        m.push(['level', parentElementLevel]);
        m.push(['nthOfType', parentNthOfType]);
        hashBaseAttributes.push([`parentUp${cnt}`, m]);

        if (parentElement.parentElement) {
          parentElement = parentElement.parentElement;
        } else {
          parentElement = false;
        }
        cnt++;
      }

      const idHash = murmurhash2(JSON.stringify(hashBaseAttributes));
      el.setAttribute(heatmapDomChangeDataIdKey, idHash);
    }

    if(getHeatmapDomChangeObserveElementsResolve) getHeatmapDomChangeObserveElementsResolve(observeSet);

    getHeatmapDomChangeObserveElementsPromise = null;
    getHeatmapDomChangeObserveElementsResolve = null;
  }, 100);

  return getHeatmapDomChangeObserveElementsPromise;
}

/**
 * DOM変更判定用監視要素判定
 * @param {*} el 
 * @returns 
 */
export function isDomChangeObserveElement(el) {
    if (!el || el.nodeType !== 1) return false;

    const rectCache = new WeakMap();
    const styleCache = new WeakMap();

    const rect = getRect(el, rectCache);
    if (rect.right <= 0 || rect.left >= window.innerWidth) return false;
    const style = getStyle(el, styleCache);
    let isOk = style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity) > 0;

    if(!isOk) return false;

    let parentEl = el.parentElement ? el.parentElement : false;
    if(!parentEl) return true;

    while(parentEl) {
      const parentRect = getRect(parentEl, rectCache);
      if (parentRect.right <= 0 || parentRect.left >= window.innerWidth) return false;
      const parentStyle = getStyle(parentEl, styleCache);
      let isParentOk = parentStyle.display !== 'none' && parentStyle.visibility !== 'hidden' && parseFloat(parentStyle.opacity) > 0;
      if(!isParentOk) return false;

      parentEl = parentEl.parentElement ? parentEl.parentElement : false;
    }

    return true;
}

/**
 * 滞在候補判定
 * @param {*} el 
 * @param {*} rectCacheArg 
 * @param {*} styleCacheArg 
 * @returns 
 */
export function isAttentionCandidateElement(el, rectCacheArg = null, styleCacheArg = null) {
  if (!el || el.nodeType !== 1) return false;

  const rectCache = rectCacheArg ?? new WeakMap();
  const styleCache = styleCacheArg ?? new WeakMap();

  const rect = getRect(el, rectCache);
  if (rect.width <= 0 || rect.height <= 0) return false;

  let currentElement = el;
  while(currentElement && currentElement.nodeType === 1) {
    const style = getStyle(currentElement, styleCache);
    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity) <= 0
    ) {
      return false;
    }
    currentElement = currentElement.parentElement;
  }

  return true;
}

/**
 * 到達アンカー要素判定
 * @param {*} el 
 * @returns 
 */
// Tracking classes alone must not hide a carousel's active/inactive class change.
export function hasHeatmapContentClassChanged(oldValue, newValue) {
  const tracking = new Set([heatmapClass, heatmapAttentionClass, heatmapArrivalClass, heatmapClickClass]);
  const normalize = value => String(value || '').split(/\s+/).filter(c => c && !tracking.has(c)).sort().join(' ');
  return normalize(oldValue) !== normalize(newValue);
}

export function isAttentionContentReady(el) {
  if (el.tagName === 'IMG') {
    if (!el.complete || !el.naturalWidth || !el.naturalHeight) return false;
    const lazy = el.getAttribute('data-src') || el.getAttribute('data-lazy-src') || el.getAttribute('data-srcset');
    if (lazy && (el.naturalWidth <= 2 && el.naturalHeight <= 2)) return false;
    if (lazy && /^data:/i.test(el.getAttribute('src') || '') && lazy !== el.getAttribute('src')) return false;
  }
  if (el.tagName === 'VIDEO' && el.readyState < 2 && !el.getAttribute('poster')) return false;
  return true;
}

// Keep different slides/media in the same DOM slot separate. Avoid currentSrc,
// which can change solely because a responsive image uses a different viewport.
export function getAttentionDataId(el) {
  const structuralId = el.getAttribute(heatmapDataIdKey);
  if (!structuralId) return null;
  let content = el.getAttribute('data-c-heatmap-content-key');
  if (!content && el.tagName === 'IMG') content = `${el.getAttribute('src') || ''}|${el.getAttribute('srcset') || ''}`;
  if (!content && el.tagName === 'VIDEO') content = `${el.getAttribute('src') || el.querySelector('source')?.getAttribute('src') || ''}|${el.getAttribute('poster') || ''}`;
  if (!content && /^(P|H[1-6]|LI|LABEL|BUTTON|A)$/.test(el.tagName) && !el.querySelector('img,video')) content = String(el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 2048);
  if (!content && el.style?.backgroundImage && el.style.backgroundImage !== 'none') content = el.style.backgroundImage;
  if (!content) return structuralId;
  const value = `${structuralId}|${el.tagName}|${content}`;
  let hash = 2166136261;
  for (let i = 0; i < value.length; i++) hash = Math.imul(hash ^ value.charCodeAt(i), 16777619);
  return `${structuralId.slice(0, 35)}-v2-${(hash >>> 0).toString(16)}`;
}

// In previews the Y viewport is deliberately not clipped: points below the fold
// still belong to the same document. Parent clipping applies in both modes.
export function getAttentionVisibleRect(el, viewportOnly = true) {
  if ((viewportOnly && document.visibilityState === 'hidden') || !isAttentionCandidateElement(el) || !isAttentionContentReady(el)) return null;
  const rect = el.getBoundingClientRect();
  let left = Math.max(0, rect.left), right = Math.min(window.innerWidth, rect.right);
  let top = viewportOnly ? Math.max(0, rect.top) : rect.top;
  let bottom = viewportOnly ? Math.min(window.innerHeight, rect.bottom) : rect.bottom;
  for (let p = el.parentElement; p; p = p.parentElement) {
    const style = getComputedStyle(p);
    const clipX = /^(hidden|clip|auto|scroll)$/.test(style.overflowX || style.overflow);
    const clipY = /^(hidden|clip|auto|scroll)$/.test(style.overflowY || style.overflow);
    if (!clipX && !clipY) continue;
    // body/html scrolling is the viewport, not an inner scroll container.
    if (p === document.body || p === document.documentElement) continue;
    const box = p.getBoundingClientRect();
    if (clipX) { left = Math.max(left, box.left + p.clientLeft); right = Math.min(right, box.left + p.clientLeft + p.clientWidth); }
    if (clipY) { top = Math.max(top, box.top + p.clientTop); bottom = Math.min(bottom, box.top + p.clientTop + p.clientHeight); }
  }
  return right > left && bottom > top ? { left, right, top, bottom, width: right - left, height: bottom - top } : null;
}

export function isAttentionBandVisible(el, rect, y) {
  if (typeof document.elementsFromPoint !== 'function') return true;
  const x = (rect.left + rect.right) / 2;
  for (const hit of document.elementsFromPoint(x, y)) {
    // pointer-events:none media may return a containing link/container instead.
    if (hit === el || el.contains(hit) || hit.contains(el)) return true;
    const style = getComputedStyle(hit);
    if (parseFloat(style.opacity) <= 0) continue;
    const colour = style.backgroundColor || '';
    const transparent = !colour || colour === 'transparent' || /rgba\([^)]*,\s*0(?:\.0+)?\s*\)$/.test(colour);
    const paints = !transparent || (style.backgroundImage && style.backgroundImage !== 'none')
      || /^(IMG|VIDEO|IFRAME|CANVAS|SVG|INPUT|SELECT|TEXTAREA)$/.test(hit.tagName)
      || String(hit.textContent || '').trim();
    if (paints) return false;
    // Empty transparent anchors often cover an LP image to make it clickable.
  }
  return false;
}

export function isArrivalElement(el) {

  const rectCache = new WeakMap();
  const styleCache = new WeakMap();

  if (!isAttentionCandidateElement(el, rectCache, styleCache)) return false;

  const fnchk = (e) => {
    if(e.tagName=== 'FOOTER') {
      return false;
    }

    const a = e.getAttribute('class');
    if(a) {
      if(a.match(/footer/i)) {
        return false;
      }
    }

    const c = getStyle(e, styleCache);
    if(c.position === 'fixed' || c.position === 'sticky') {
      return false;
    }

    if(c.display === 'none') {
      return false;
    }
    
    const r = getRect(e, rectCache);
    if (r.height <= 2 || r.width <= 2) {
      return false;
    }

    return true;
  };

  if(!fnchk(el)) return false;

  let parentEl = el.parentElement ? el.parentElement : false;

  while(parentEl) {
    const isOk = fnchk(parentEl);
    if(!isOk) return false;

    parentEl = parentEl.parentElement ? parentEl.parentElement : false;
  }

  return true;
}

/**
 * ビューポート内可視要素判定
 * @param {*} el 
 * @param {*} rectCacheArg 
 * @param {*} styleCacheArg 
 * @returns 
 */
export function isInViewportVisibility(el, rectCacheArg = null, styleCacheArg = null) {
    const rectCache = rectCacheArg ?? new WeakMap();
    const styleCache = styleCacheArg ?? new WeakMap();

    const rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    if (rect.right <= 0 || rect.left >= window.innerWidth) return false;
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return false;
    const style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity) > 0;
}

/**
 * 可視状態かどうかだけ
 * @param {*} el 
 * @param {*} rectCacheArg 
 * @param {*} styleCacheArg 
 * @returns 
 */
export function isVisibilityElement(el, rectCacheArg = null, styleCacheArg = null) {
    if (!el || el.nodeType !== 1) return false;

    const rectCache = rectCacheArg ?? new WeakMap();
    const styleCache = styleCacheArg ?? new WeakMap();

    const rect = getRect(el, rectCache);
    if (rect.right <= 0 || rect.left >= window.innerWidth) return false;
    const style = getStyle(el ,styleCache);
    let isOk = style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity) > 0;

    if(!isOk) return false;

    let parentEl = el.parentElement ? el.parentElement : false;
    if(!parentEl) return true;

    while(parentEl) {
      const parentRect = getRect(parentEl, rectCache);
      if (parentRect.right <= 0 || parentRect.left >= window.innerWidth) return false;
      const parentStyle = getStyle(parentEl, styleCache);
      let isParentOk = parentStyle.display !== 'none' && parentStyle.visibility !== 'hidden' && parseFloat(parentStyle.opacity) > 0;
      if(!isParentOk) return false;

      parentEl = parentEl.parentElement ? parentEl.parentElement : false;
    }

    return true;
}

/**
 * 浮いた要素かどうか
 * @param {*} el 
 * @param {*} rectCacheArg 
 * @param {*} styleCacheArg
 * @returns 
 */
export function isFixed(el, rectCacheArg = null, styleCacheArg = null) {

  const rectCache = rectCacheArg ?? new WeakMap();
  const styleCache = styleCacheArg ?? new WeakMap();

  const style = getStyle(el, styleCache);

  if(style.position === 'fixed') return true;

  let parentEl = el.parentElement ? el.parentElement : false;
  if(!parentEl) return false;

  while(parentEl) {
    const parentStyle = getStyle(parentEl, styleCache);
    if(parentStyle.position === 'fixed') return true;

    parentEl = parentEl.parentElement ? parentEl.parentElement : false;
  }

  return false;
}

/**
 * rect系のキャッシュ
 * @param {*} el 
 * @param {*} chache 
 * @returns 
 */
export function getRect (el, chache) {
  const cached = chache.get(el);
  if (cached) return cached;
  const r = el.getBoundingClientRect();
  chache.set(el, r);
  return r;
};

/**
 * スタイル系のキャッシュ
 * @param {*} el 
 * @param {*} chache 
 * @returns 
 */
export function getStyle (el, chache) {
  const cached = chache.get(el);
  if (cached) return cached;
  const s = getComputedStyle(el);
  chache.set(el, s);
  return s;
};

/**
 * ページ識別用ステートキー判定
 * @param {*} dataIds 
 * @returns 
 */
export function pickLpStateKeyValue(dataIds) {
  const defaultValue = 'default';

  if(!dataIds) return defaultValue;

  const styleCache = new WeakMap();
  const rectCache = new WeakMap();

  // 自分自身が非表示かどうか
  const hasSelfHiddenStyle = (el) => {
    if (!el || el.nodeType !== 1) return false;
    const style = getStyle(el, styleCache);
    return style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0;
  };

  // 祖先が非表示かどうか
  const hasAncestorHiddenStyle = (el) => {
    if (!el || el.nodeType !== 1) return false;
    let currentElement = el?.parentElement;
    while(currentElement && currentElement.nodeType === 1) {
      if (currentElement.tagName === 'MAIN' || currentElement.tagName === 'BODY') {
        break;
      }

      const style = getStyle(currentElement, styleCache);

      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0) {
        return true;
      }

      currentElement = currentElement.parentElement;
    }

    return false;
  };
  
  for(const dataId of (dataIds ?? [])) {
    if(!dataId) continue;

    const el = document.querySelector(`[${heatmapDomChangeDataIdKey}="${dataId}"]`);
    if (!el) continue;
    if (hasSelfHiddenStyle(el)) continue;
    if (hasAncestorHiddenStyle(el)) continue;

    return dataId;
  }

  return defaultValue;
}

let lpStateDataIdsFetchAbort = null;
/**
 * 管理画面上のページ識別用キーを取得
 * @param {*} domain 
 * @param {*} currentPathname 
 * @returns 
 */
export async function fetchLpStateDataIds(domain, currentPathname) {
  let uriPath = currentPathname;
  if(uriPath.endsWith('/')) {
    uriPath += 'index.json';
  } else {
    uriPath += '.json';
  }

  if(lpStateDataIdsFetchAbort) lpStateDataIdsFetchAbort.abort();

  lpStateDataIdsFetchAbort = new AbortController();

  try {
    const res = await fetch(`${HEATMAP_STATE_DATA_IDS_JSON_WS}/${domain}${uriPath}`, {
      mode: "cors",
      signal: lpStateDataIdsFetchAbort.signal
    });
    const data = await res.json();
    return data.map(d => d?.dataId).filter(Boolean);
  } catch (e) {
    if (e?.name === 'AbortError') return [];
    return []; 
  }
}


/**
 * ページ全体の高さ取得
 * @returns 
 */
export function getPageHeight() {
  const doc = document.scrollingElement;
  const docHeight = Math.max(doc.scrollHeight, doc.clientHeight);
  return docHeight;
}

/**
 *
 * ハッシュ作成用
 * @param {*} str
 * @param {*} seed
 * @returns
 */
export function murmurhash2(str, seed = 0) {
    let l = str.length,
        h = seed ^ l,
        i = 0,
        k;

    while (l >= 4) {
        k =
        ((str.charCodeAt(i) & 0xff)) |
        ((str.charCodeAt(i + 1) & 0xff) << 8) |
        ((str.charCodeAt(i + 2) & 0xff) << 16) |
        ((str.charCodeAt(i + 3) & 0xff) << 24);

        k = (k * 0x5bd1e995) >>> 0;
        k ^= k >>> 24;
        k = (k * 0x5bd1e995) >>> 0;

        h = (h * 0x5bd1e995) >>> 0;
        h ^= k;

        i += 4;
        l -= 4;
    }

    switch (l) {
        case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
        h ^= (str.charCodeAt(i) & 0xff);
        h = (h * 0x5bd1e995) >>> 0;
    }

    h ^= h >>> 13;
    h = (h * 0x5bd1e995) >>> 0;
    h ^= h >>> 15;

    return (h >>> 0).toString(16);
}

/**
 *
 * 特定の刻みで数字丸める用関数
 * range=5なら5刻み 例）3 → 5, 7 → 5, 9 → 10} val
 * @param {*} val
 * @param {*} range
 * @returns
 */
export function roundCalc(val, range) {
    return Number(Math.round(val / range) * range);
}

/**
 *
 * 特定の刻みで数字丸める用関数
 * 切り捨て版
 * @param {*} val
 * @param {*} range
 * @returns
 */
export function floorCalc(val, range) {
  return Number(Math.floor(val / range) * range);
}

/**
 * 0～1の間に切り詰める
 * @param {*} v 
 * @returns 
 */
export function clamp01(v) {
    return Number(Math.min(1, Math.max(0, v)));
}

/**
 * 指定桁で小数点以下切り捨て
 * @param {*} val 
 * @param {*} digit 
 * @returns 
 */
export function digitFloor(val, digit) {
  const f = Math.pow(10, digit);
  return Number(Math.floor(val * f) / f);
}

/**
 * PHPでいうemptyのようなもの
 * @param {*} val
 * @returns
 */
export function empty(val) {
    if (val == null || val == undefined || val == 0 || val == '') {
        return true;
    }

    if (val instanceof Array) {
        if (val.length == 0) {
            return true;
        }
    }

    return false;
}

/**
 * GETパラメータオブジェクト
 * @returns 
 */
export const queryStringMap = (() => {

    let queryString = window.location.search;
    const queryObject = new Object();
    if(queryString){
      queryString = queryString.substring(1);
      const parameters = queryString.split('&');

      for (var i = 0; i < parameters.length; i++) {
        const element = parameters[i].split('=');

        try {
          const paramName = decodeURIComponent(element[0] || '');
          const paramValue = decodeURIComponent(element[1] ?? '');

          queryObject[paramName] = paramValue;
        } catch {

        }
      }
    }

    return queryObject;
})();

/**
 * クッキー取得
 * @param {*} name 
 * @returns 
 */
export function getCookie(name) {
    var raw = document.cookie || "";
    if (!raw) return null;
    var pairs = raw.split(";").map(function (s) { return s.trim(); });
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eq = pair.indexOf("=");
        var k = eq === -1 ? pair : pair.slice(0, eq);
        if (k === name) {
            var v = eq === -1 ? "" : pair.slice(eq + 1);
            try { return decodeURIComponent(v); } catch (e) { return v; }
        }
    }
    return null;
}

/**
 * クッキーに値セット
 * @param {*} name 
 * @param {*} value 
 * @param {*} opts 
 */
export function setCookie(name, value, opts) {
    opts = opts || {};
    var cookie = name + "=" + encodeURIComponent(value);

    if (typeof opts.maxAge === "number") cookie += "; Max-Age=" + Math.floor(opts.maxAge);
    if (opts.expires instanceof Date) cookie += "; Expires=" + opts.expires.toUTCString();
    cookie += "; Path=" + (opts.path || "/");
    if (opts.domain) cookie += "; Domain=" + opts.domain;
    if (opts.secure) cookie += "; Secure";
    if (opts.sameSite) cookie += "; SameSite=" + opts.sameSite;

    document.cookie = cookie;
}

/**
 * クッキー削除
 * @param {*} name 
 * @param {*} opts 
 */
export function deleteCookie(name, opts) {
    opts = opts || {};
    // もとの Path/Domain と同じ指定で消す必要があります
    setCookie(name, "", {
        path: opts.path,
        domain: opts.domain,
        expires: new Date(0)
    });
}

/**
 * 滞在監視の刻み閾値の取得
 * @param {*} elHeight 
 * @returns 
 */
export function decideThresholds(elHeight) {
    const baseHeight = 360;
    const h = Math.max(1, Math.floor(elHeight));
    if(h <= baseHeight / 2) return 0.5;
    if(h <= baseHeight) return 0.25;
    if(h <= baseHeight * 2) return 0.125;
    return 0.0625;
}

/**
 * 日付フォーマット
 * @param {*} d 
 * @returns 
 */
export function dateFormatYmdStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * スリープ
 * @param {*} ms 
 * @returns 
 */
export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(() => {
    resolve(true);
  }, ms));
}

/**
 * sha1関数
 * @param {*} str 
 * @returns 
 */
export async function sha1(str) {
  // 1. 文字列を Uint8Array にエンコード
  const msgUint8 = new TextEncoder().encode(str);

  // 2. SHA-1 でハッシュ化（ArrayBuffer が返る）
  const hashBuffer = await crypto.subtle.digest('SHA-1', msgUint8);

  // 3. ArrayBuffer を 16進数文字列に変換
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return hashHex;
}

/*!
 * Includes heatmap.js (h337) – MIT License
 *   Copyright (c) 2008-2025 Patrick Wied
 *   https://github.com/pa7/heatmap.js
 *
 * Also includes a modified renderer ("h337square") based on heatmap.js – MIT
 *   Modifications Copyright (c) 2025 Your Company, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to do so, subject to the
 * following conditions:
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
